var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-edit" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: (_vm.isNew ? "New" : "Edit") + " behaviour" } },
        [
          !_vm.isNew && _vm.isReceiving
            ? _c("Loader", { attrs: { size: 40 } })
            : _c(
                "Form",
                [
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "title" } },
                      [_vm._v("Title")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "title", type: "text" },
                        domProps: { value: _vm.behaviour.title },
                        on: {
                          change: function($event) {
                            return _vm.updateBehaviourProperty($event, "title")
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-md-2",
                        attrs: { for: "description" }
                      },
                      [_vm._v("Description")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: { id: "description", type: "text" },
                        domProps: { value: _vm.behaviour.description },
                        on: {
                          change: function($event) {
                            return _vm.updateBehaviourProperty(
                              $event,
                              "description"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "maxStars" } },
                      [_vm._v("Available stars per day")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "maxStars", type: "number" },
                        domProps: { value: _vm.behaviour.maxNoOfStars },
                        on: {
                          change: function($event) {
                            return _vm.updateBehaviourProperty(
                              $event,
                              "maxNoOfStars"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-md-2",
                        attrs: { for: "maxComments" }
                      },
                      [_vm._v("Available comments per day")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "maxComments", type: "number" },
                        domProps: { value: _vm.behaviour.maxNoOfComments },
                        on: {
                          change: function($event) {
                            return _vm.updateBehaviourProperty(
                              $event,
                              "maxNoOfComments"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group row" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-md-2",
                          attrs: { for: "behaviourDateRange" }
                        },
                        [_vm._v("Date range")]
                      ),
                      _vm._v(" "),
                      _c("v-date-picker", {
                        staticClass: "col-md-5",
                        attrs: { mode: "range", id: "behaviourDateRange" },
                        model: {
                          value: _vm.calendarData,
                          callback: function($$v) {
                            _vm.calendarData = $$v
                          },
                          expression: "calendarData"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.global == true
                    ? _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-2",
                            attrs: { for: "timezone" }
                          },
                          [_vm._v("Timezone")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-5" },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "timezone",
                                options: _vm.getTimezoneOptions()
                              },
                              model: {
                                value: _vm.behaviour.timezone,
                                callback: function($$v) {
                                  _vm.$set(_vm.behaviour, "timezone", $$v)
                                },
                                expression: "behaviour.timezone"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.global == false
                    ? _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-2",
                            attrs: { for: "timezone" }
                          },
                          [_vm._v("Group")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-5" },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "group",
                                label: "name",
                                options: _vm.groups
                              },
                              model: {
                                value: _vm.selectedGroup,
                                callback: function($$v) {
                                  _vm.selectedGroup = $$v
                                },
                                expression: "selectedGroup"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", id: "isPublic" },
                        domProps: { checked: _vm.behaviour.public == true },
                        on: {
                          change: function($event) {
                            return _vm.togglePublic()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "isPublic" } }, [
                        _vm._v("Active")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          id: "isGlobal",
                          disabled: !_vm.showGlobalOption()
                        },
                        domProps: { checked: _vm.behaviour.global == true },
                        on: {
                          change: function($event) {
                            return _vm.toggleGlobal()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "isGlobal" } }, [
                        _vm._v("Global")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.errorsList, function(error) {
                    return _c(
                      "b-alert",
                      {
                        key: error,
                        staticClass: "alert-sm w-25",
                        attrs: {
                          variant: "danger",
                          show: _vm.errorsList.length > 0
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(error) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isOverlaping && _vm.errorsList.length == 0
                    ? _c(
                        "div",
                        [
                          _vm._v(
                            "\n                There is another behaviour configured in the chosen time interval. Are you sure you want to add\n                another one?\n                "
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.saveOverlapingBehaviour()
                                }
                              }
                            },
                            [
                              _vm.isUpdating
                                ? _c("Loader")
                                : _c("span", [_vm._v("Yes")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function() {
                                  _vm.isOverlaping = false
                                }
                              }
                            },
                            [
                              _vm.isUpdating
                                ? _c("Loader")
                                : _c("span", [_vm._v("No")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "b-button-toolbar",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.saveBehaviour()
                                }
                              }
                            },
                            [
                              _vm.isUpdating
                                ? _c("Loader")
                                : _c("span", [_vm._v("Save")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "default" },
                              on: {
                                click: function($event) {
                                  return _vm.goBack()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Back\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "page-title" }, [
      _vm._v("Behaviour - "),
      _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Detail")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }